import axios from "axios";

import getEnv from "@/config/env";
import { deleteCurrentUser, getCurrentUser } from "@/helpers/helper";
import store from "@/store";
import router from "@/router";
import { REFRESHTOKEN } from "@/store/_actiontypes";

let isRefreshingToken = false;
let callbacks = [];
let ChorusApi = axios.create({
  withCredentials: false,
  baseURL: getEnv("VUE_APP_CHORUS_API"),
});

ChorusApi.interceptors.request.use(
  async (request) => {
    const user = getCurrentUser();

    request.headers["X-Client-Id"] = getEnv("VUE_APP_CLIENT_ID");
    request.headers["X-Client-Secret"] = getEnv("VUE_APP_CLIENT_SECRET");
    request.headers["Project-Id"] = store.getters["project/activeProjectId"];

    if (user && user.access_token) {
      request.headers["Authorization"] = `Bearer ${user.access_token}`;
    }

    request.headers["Accept-Language"] = "en-gb";
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ChorusApi.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      let user = getCurrentUser();

      if (user && user.refresh_token) {
        const originalRequest = error.config;

        if (!originalRequest.sent) {
          originalRequest.sent = true;

          if (!isRefreshingToken) {
            isRefreshingToken = true;

            return store
              .dispatch(
                `account/${REFRESHTOKEN}`,
                { refresh_token: user.refresh_token },
                { root: true }
              )
              .then(() => {
                isRefreshingToken = false;
                tokenRefreshed();
                originalRequest.headers.Authorization = `Bearer ${store.state.account.user.access_token}`;
                return ChorusApi(originalRequest);
              })
              .catch(() => {
                deleteCurrentUser();
                router.push("/login");
                return Promise.reject(error);
              });
          }
          // Always add to retry queue except the first request.
          return new Promise((resolve) => {
            addCallback(() => {
              originalRequest.headers.Authorization = `Bearer ${store.state.account.user.access_token}`;
              resolve(ChorusApi(originalRequest));
            });
          });
        }
      }
    }
    return Promise.reject(error);
  }
);

let tokenRefreshed = () => {
  const pending = [...callbacks];
  callbacks = [];
  pending.forEach((cb) => cb());
};

let addCallback = (callback) => {
  callbacks.push(callback);
};

export default ChorusApi;
